module.exports = __webpack_public_path__ + "static/media/smartcode-logo.692e07be.png";